// extracted by mini-css-extract-plugin
export var pHeaderMenuLogged = "vg";
export var lHeader__menuLogged = "wg";
export var aLogoLovePeace1 = "xg";
export var aLogoLovePeace2 = "yg";
export var aButton1 = "zg";
export var aButton2 = "Ag";
export var aButton3 = "Bg";
export var aButton4 = "Cg";
export var aButton5 = "Dg";
export var aButtonHeaderLogin = "Eg";
export var aButtonHeaderRegister = "Fg";
export var aButtonBig = "Gg";
export var aButtonRegister = "Hg";
export var aButtonLogin = "Ig";
export var aButtonContinuation = "Jg";
export var icon = "Kg";
export var aButtonHeaderSpLogin = "Lg";
export var pHeaderMenu = "Mg";
export var pHeaderMenu__item = "Ng";
export var pHeaderMenu__itemSp = "Og";
export var pHeaderMenu__itemPc = "Pg";
export var lHeader = "Qg";
export var lHeader__inner = "Rg";
export var lHeader__right = "Sg";
export var lHeader__left = "Tg";
export var animationMarquee = "Ug";